import { connect } from 'react-redux'
import AddressListComponent from '../components/AddressList'
import {
  fetchAddress,
  fetchAllStates,
} from '../actions/ApiReqest'
import {
  switchToNewMode,
  toggleLoader,
  resetAddress,
  setMerchantCountry,
  updateCountryCode,
  showAddressFeedback,
  hideAddressFeedback,
} from '../actions'

const mapStateToProps = (state) => ({
  addressList: state.address.list ? state.address.list : [],
  merchantCanonicalName: state.merchant.canonical_name,
  isLoading: state.address.isLoading,
  selectedAddressID: state.address.selectedAddress.id,
  merchantCountry: state.merchant.home_country,
  allCountries: state.address.allCountries,
  showAddressFeedbackModal: state.address.showAddressFeedback,
  showDeleteModal: state.address.showDeleteAddressModal,
  showDeleteErrorMessage: state.address.delete.error,
})

const mapDispatchToProps = (dispatch) => ({
  fetchAddress: () => {
    dispatch(toggleLoader(true))
    dispatch(fetchAddress())
  },
  onSelectNewAddress: () => {
    dispatch(switchToNewMode())
    dispatch(resetAddress())
  },
  setMerchantCountry: (country) => {
    dispatch(setMerchantCountry(country))
  },
  setPhoneCode: (allCountries, merchantCountry) => {
    const country = allCountries.find((c) => (c.code === merchantCountry))
    dispatch(updateCountryCode(country.phone_code))
  },
  showAddressFeedback: () => {
    dispatch(showAddressFeedback())
  },
  hideAddressFeedback: () => {
    dispatch(hideAddressFeedback())
  },
  fetchAllStates: (country) => {
    dispatch(fetchAllStates(country))
  },
})

const AddressList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddressListComponent)

export default AddressList
